module.exports.acos = require('./acos')
